import React, { FC } from 'react';
import UserAppClientCreateEditForm from './createEditForm/UserAppClientCreateEditForm';
import { TABLE } from 'shared/constans';
import { useSuperQuery } from '@vadiun/react-hooks-legacy';
import useCompanies from '../../services/companyQueries';
import { UserFormValues } from '../../models/appUserModel';
import { Loading } from 'shared/components';

interface UserAppClientCreateProps {
  setVisiblePage: (visiblePage: any) => void;
  createUserApp: (values: UserFormValues) => Promise<void>;
}

const UserAppClientCreate: FC<UserAppClientCreateProps> = ({
  setVisiblePage,
  createUserApp
}) => {
  const CompaniesService = useCompanies();

  const { data: companies } = useSuperQuery(CompaniesService.getCompanies, {
    showSpinner: true
  });

  const handleCancel = () => {
    setVisiblePage(TABLE);
  };

  if (!(companies && companies.length > 0)) {
    return <Loading />;
  }

  return (
    <div className="flex w-full justify-center">
      <UserAppClientCreateEditForm
        onSubmit={createUserApp}
        onCancel={handleCancel}
        companies={companies}
      />
    </div>
  );
};

export default UserAppClientCreate;
